<template>
  <div class="crm-export">
    <template v-if="title==='导出客户'">
      <el-button
        v-if="$authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#export')"
        type="primary"
        size="small"
        @click="handleClick"
      >{{ title }}</el-button>
    </template>
    <div v-else>
      <a @click="handleClick">{{ title }}</a>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/utils/format.js'
import {
  getAllClientInfo,
  customerErrorExcel,
  getcustomerImportExcel
} from '@/api/crm/clientInfo'
export default {
  props: {
    title: {
      required: true,
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    headerList: {
      type: Array,
      default: () => {
        return []
      }
    },
    errFileName: {
      type: String,
      default: ''
    },
    conditionsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    handleClick() {
      const self = this
      let fileName
      let header
      let filter
      // 根据筛选条件导出客户
      if (this.title === '导出客户') {
        let list = []
        const option = {
          source: 'AICC_CRM',
          conditions: this.conditionsList
        }
        getAllClientInfo(option).then(res => {
          fileName = '客户导出数据'
          list = res.data
          this.headerList.forEach(item => {
            if (item.nameEn === 'label') {
              item.nameEn = 'labelRespList'
            }
          })
          header = this.headerList.map(item => item.name)
          filter = this.headerList.map(item => item.nameEn)
          import('@/vendor/Export2Excel').then(excel => {
            const filterVal = filter
            const data = this.formatJson(filterVal, list)
            excel.export_json_to_excel({
              header,
              data,
              filename: fileName
            })
          })
        })
      } else if (this.title === '下载客户列表导入模板') {
        getcustomerImportExcel().then(res => {
          const fileName = '客户列表导入模板'
          self.downloadFile(res, fileName)
        })
      } else if (this.title === '错误文件下载') {
        const options = {
          errFileName: this.errFileName
        }
        customerErrorExcel(options).then(res => {
          self.downloadFile(res, this.errFileName)
        })
      }
    },
    // 下载流文件
    downloadFile(content, filename) {
      const blob = new Blob([content], { type: 'application/vnd.ms-excel' }) // 构造一个blob对象来处理数据
      const fileName = filename
      // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      if ('download' in document.createElement('a')) {
        // 支持a标签download的浏览器
        const link = document.createElement('a') // 创建a标签
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName)
      }
    },
    // 下载数据格式化
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'createDate' || j === 'modifyDate') {
            if (v[j]) {
              return parseTime(v[j])
            } else {
              return ''
            }
          } else if (j === 'labelRespList') {
            return v[j].map(item => item.name).join(',')
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>

<style scoped lang="scss">
.crm-export {
  display: inline-block;
  .el-button {
    margin-left: 10px;
  }
  a {
    color: #167ff9;
    margin-left: 10px;
    vertical-align: middle;
  }
  a:hover {
    cursor: pointer;
    border-bottom: 1px solid #167ff9;
  }
}
.excel-upload-input {
  display: none;
  z-index: -9999;
}
.drop {
  margin: 0 auto;
  float: left;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
